import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Observable, empty, from, of } from 'rxjs';
import { EmailTemplateModel } from '../../models/email-template-model';
import { EmailTemplateEditorComponent } from '../../components/email-template-editor/email-template-editor.component';
import { EmailTemplateService } from '../../services/email-template.service';

@Component({
  selector: 'mojo-email-templates-page',
  templateUrl: './email-templates-page.component.html',
})
export class EmailTemplatesPageComponent implements OnDestroy {
  @ViewChild(EmailTemplateEditorComponent, { static: true }) editor;
  isAlive: boolean = true;

  emailTemplates: Observable<EmailTemplateModel[]>;
  loading: Observable<boolean>;

  constructor(
    private readonly emailTemplateService: EmailTemplateService
  ) {

    this.emailTemplates = this.emailTemplateService.getAll();
    this.loading = this.emailTemplateService.getLoading();

    this.emailTemplates.subscribe(models => {
      console.log(models);
    });
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  onRowClick(selectedTemplate) {
    const x = event;
    this.editor.editTemplate(selectedTemplate);
  }

}
